// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.counter {
    display: inline;
    margin: 0 10px;
}
.counter button {
    padding: 0;
    vertical-align: middle;
}
.counter button img {
    display: block;
    height: 16px;
}
.counter input {
    height: 14px;
    vertical-align: middle;
    margin-left: -1px;
    margin-right: -1px;
}
.counter label {
    padding: 0 5px;
}
`, "",{"version":3,"sources":["webpack://./src/ui/widgets/counter.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,cAAc;AAClB;AACA;IACI,UAAU;IACV,sBAAsB;AAC1B;AACA;IACI,cAAc;IACd,YAAY;AAChB;AACA;IACI,YAAY;IACZ,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,cAAc;AAClB","sourcesContent":[".counter {\n    display: inline;\n    margin: 0 10px;\n}\n.counter button {\n    padding: 0;\n    vertical-align: middle;\n}\n.counter button img {\n    display: block;\n    height: 16px;\n}\n.counter input {\n    height: 14px;\n    vertical-align: middle;\n    margin-left: -1px;\n    margin-right: -1px;\n}\n.counter label {\n    padding: 0 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
